// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Agencies Page Styles
   ============================================ */

/* Override container rounding */
.agencies-table-wrap {
  border-radius: 0;
  border-left: none;
  border-right: none;
}

/* Auto layout — columns size to content */
table.agencies-table {
  table-layout: auto;
}

.agencies-table th,
.agencies-table td {
  white-space: nowrap;
}

/* Several admins can run one agency, so the cell holds a stack of them rather
   than a single name. The gap keeps two people from reading as one. */
.agencies-admins {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* Clients multi-select empty state */
.agencies-clients-empty {
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 12px;
}

/* ============================================
   Discount Badges
   ============================================ */

.discount-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.discount-auto {
  background: rgba(39, 174, 96, 0.12);
  color: #27ae60;
}

.discount-manual {
  background: rgba(243, 156, 18, 0.12);
  color: #e67e22;
}

.discount-source {
  font-weight: 400;
  opacity: 0.8;
  font-size: 11px;
}

/* ============================================
   Discount Stages Modal
   ============================================ */

.discount-stages-modal {
  max-width: 560px;
}

.discount-current {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--bg-tertiary, #f8f9fa);
  border-radius: 10px;
  margin-bottom: 16px;
}

.discount-current-label {
  font-size: 13px;
  color: var(--text-secondary, #6b7280);
}

.discount-spend-info {
  font-size: 12px;
  color: var(--text-secondary, #6b7280);
  margin-left: auto;
}

.discount-stages-table {
  margin-bottom: 16px;
}

.discount-stages-table .stage-active {
  background: rgba(39, 174, 96, 0.04);
}

.discount-stage-status {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}

.discount-stage-status.status-active {
  background: rgba(39, 174, 96, 0.12);
  color: #27ae60;
}

.discount-stage-status.status-future {
  background: rgba(52, 152, 219, 0.12);
  color: #3498db;
}

.discount-add-form {
  margin-top: 12px;
}

.discount-add-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.discount-input {
  padding: 8px 12px;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  background: var(--bg-primary, #fff);
  color: var(--text-primary, #1a1a2e);
  flex: 1 1;
}

.discount-input:focus {
  outline: none;
  border-color: #8E3A9A;
  box-shadow: 0 0 0 3px rgba(142, 58, 154, 0.1);
}

.discount-date-wrap {
  position: relative;
  flex: 1 1;
}

.discount-date-wrap .discount-date-native {
  color: transparent;
  width: 100%;
  box-sizing: border-box;
}

.discount-date-wrap .discount-date-native::-webkit-datetime-edit {
  color: transparent;
}

.discount-date-display {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 13px;
  font-family: inherit;
  color: var(--text-primary, #1a1a2e);
  pointer-events: none;
}

/* ============================================
   Discount Tiers Page
   ============================================ */

.discount-tier-row {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 10px;
}

.discount-tier-remove {
  width: 36px;
  height: 36px;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-tertiary, #bbb);
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.discount-tier-remove svg {
  width: 16px;
  height: 16px;
}

.discount-tier-remove:hover {
  background: rgba(231, 76, 60, 0.08);
  color: #e74c3c;
}

.discount-tier-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary, #6b7280);
  background: none;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.discount-tier-add svg {
  width: 15px;
  height: 15px;
}

.discount-tier-add:hover {
  border-color: var(--accent-orange, #FF6B4A);
  color: var(--accent-orange, #FF6B4A);
}
`, "",{"version":3,"sources":["webpack://./src/styles/agencies.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,gCAAgC;AAChC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;sEACsE;AACtE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;iDAEiD;;AAEjD;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,mCAAmC;EACnC,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;AACtC","sourcesContent":["/* ============================================\n   Agencies Page Styles\n   ============================================ */\n\n/* Override container rounding */\n.agencies-table-wrap {\n  border-radius: 0;\n  border-left: none;\n  border-right: none;\n}\n\n/* Auto layout — columns size to content */\ntable.agencies-table {\n  table-layout: auto;\n}\n\n.agencies-table th,\n.agencies-table td {\n  white-space: nowrap;\n}\n\n/* Several admins can run one agency, so the cell holds a stack of them rather\n   than a single name. The gap keeps two people from reading as one. */\n.agencies-admins {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* Clients multi-select empty state */\n.agencies-clients-empty {\n  padding: 20px;\n  text-align: center;\n  color: #999;\n  font-size: 12px;\n}\n\n/* ============================================\n   Discount Badges\n   ============================================ */\n\n.discount-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.discount-auto {\n  background: rgba(39, 174, 96, 0.12);\n  color: #27ae60;\n}\n\n.discount-manual {\n  background: rgba(243, 156, 18, 0.12);\n  color: #e67e22;\n}\n\n.discount-source {\n  font-weight: 400;\n  opacity: 0.8;\n  font-size: 11px;\n}\n\n/* ============================================\n   Discount Stages Modal\n   ============================================ */\n\n.discount-stages-modal {\n  max-width: 560px;\n}\n\n.discount-current {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--bg-tertiary, #f8f9fa);\n  border-radius: 10px;\n  margin-bottom: 16px;\n}\n\n.discount-current-label {\n  font-size: 13px;\n  color: var(--text-secondary, #6b7280);\n}\n\n.discount-spend-info {\n  font-size: 12px;\n  color: var(--text-secondary, #6b7280);\n  margin-left: auto;\n}\n\n.discount-stages-table {\n  margin-bottom: 16px;\n}\n\n.discount-stages-table .stage-active {\n  background: rgba(39, 174, 96, 0.04);\n}\n\n.discount-stage-status {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.discount-stage-status.status-active {\n  background: rgba(39, 174, 96, 0.12);\n  color: #27ae60;\n}\n\n.discount-stage-status.status-future {\n  background: rgba(52, 152, 219, 0.12);\n  color: #3498db;\n}\n\n.discount-add-form {\n  margin-top: 12px;\n}\n\n.discount-add-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.discount-input {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color, #e5e7eb);\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary, #1a1a2e);\n  flex: 1;\n}\n\n.discount-input:focus {\n  outline: none;\n  border-color: #8E3A9A;\n  box-shadow: 0 0 0 3px rgba(142, 58, 154, 0.1);\n}\n\n.discount-date-wrap {\n  position: relative;\n  flex: 1;\n}\n\n.discount-date-wrap .discount-date-native {\n  color: transparent;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.discount-date-wrap .discount-date-native::-webkit-datetime-edit {\n  color: transparent;\n}\n\n.discount-date-display {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 13px;\n  font-family: inherit;\n  color: var(--text-primary, #1a1a2e);\n  pointer-events: none;\n}\n\n/* ============================================\n   Discount Tiers Page\n   ============================================ */\n\n.discount-tier-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.discount-tier-remove {\n  width: 36px;\n  height: 36px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-tertiary, #bbb);\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.discount-tier-remove svg {\n  width: 16px;\n  height: 16px;\n}\n\n.discount-tier-remove:hover {\n  background: rgba(231, 76, 60, 0.08);\n  color: #e74c3c;\n}\n\n.discount-tier-add {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary, #6b7280);\n  background: none;\n  border: 1px dashed rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.discount-tier-add svg {\n  width: 15px;\n  height: 15px;\n}\n\n.discount-tier-add:hover {\n  border-color: var(--accent-orange, #FF6B4A);\n  color: var(--accent-orange, #FF6B4A);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
